export default __webpack_public_path__ + "static/media/maternidad3_c.727da1ed.jpg";